module.exports = __webpack_public_path__ + "static/screen-1-4bdb270d98951dcac59d026525a66219.png";